import { QueryClient } from '@tanstack/react-query';

/**
 * Single QueryClient instance for the app.
 *
 * Defaults are tuned for our backend pattern (admin config / preferences /
 * conversations are user-scoped data that changes infrequently):
 * - staleTime 30s: avoid refetching on every component remount, but keep
 *   data fresh enough for cross-tab edits to surface within half a minute.
 * - refetchOnWindowFocus true: catch changes another tab made when the
 *   user comes back to this one.
 * - retry 1: fail fast on auth/network errors; the user can refresh.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
